export const fonts = {
	fontFamily: 'AmericaExpandedRegular',
	fontFamilyTitle: 'AmericaExpandedRegular',
}
